var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfinity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 7,
    viewBox: "0 0 15 7",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 0.136719C10.725 0.136719 9.875 0.486719 9.26875 1.09297L4.875 4.99297C4.475 5.39297 3.94375 5.61172 3.375 5.61172C2.20625 5.61172 1.25625 4.66797 1.25625 3.49922C1.25625 2.33047 2.20625 1.38672 3.375 1.38672C3.94375 1.38672 4.475 1.60547 4.9 2.03047L5.60625 2.65547L6.55 1.81797L5.7625 1.12422C5.125 0.486719 4.275 0.136719 3.375 0.136719C1.5125 0.136719 0 1.64922 0 3.49922C0 5.34922 1.5125 6.86172 3.375 6.86172C4.275 6.86172 5.125 6.51172 5.73125 5.90547L10.125 2.00547C10.525 1.60547 11.0563 1.38672 11.625 1.38672C12.7937 1.38672 13.7437 2.33047 13.7437 3.49922C13.7437 4.66797 12.7937 5.61172 11.625 5.61172C11.0625 5.61172 10.525 5.39297 10.1 4.96797L9.3875 4.33672L8.44375 5.17422L9.2375 5.87422C9.875 6.50547 10.7188 6.85547 11.625 6.85547C13.4875 6.85547 15 5.34922 15 3.49297C15 1.63672 13.4875 0.136719 11.625 0.136719Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinity);
export default __webpack_public_path__ + "static/media/infinity.23c07f4d28d319cc8a8e7149948009a6.svg";
export { ForwardRef as ReactComponent };